import { ContractsTaxiForwardingContractItem } from "../../../../../../common/services/contracts/taxi-forwarding/contract/contracts-taxi-forwarding-contract";
import SelectOptionTaxiContractsComponent from "./types/select-taxi-taxi-contracts";

const createTaxiContractSelectOption = (
  taxiCorporation: ContractsTaxiForwardingContractItem,
): SelectOptionTaxiContractsComponent => {
  return {
    label: taxiCorporation.displayName,
    value: taxiCorporation,
  };
};

const createTaxiContractsSelectOptions = (
  responseTaxiCorporations: ContractsTaxiForwardingContractItem[],
): SelectOptionTaxiContractsComponent[] => {
  return responseTaxiCorporations.map(createTaxiContractSelectOption);
};

const taxiContractFactory = {
  createTaxiContractsSelectOptions,
};

export default taxiContractFactory;
